import { useCallback, useEffect, useState } from "react";

import { useNotify, useSubscribe } from "data/messages/hooks";

export function useSubscribeToClientCardTasks(onUpdate) {
  const [isRefetch, refetch] = useState(false);
  const notify = useNotify("CLIENT_CARD_TASKS");

  useEffect(() => {
    if (isRefetch) {
      onUpdate();
      refetch(false);
      notify([]);
    }
  }, [isRefetch, onUpdate, notify]);

  useSubscribe(
    "clientCardTasks",
    useCallback((reloadSet) => {
      if (reloadSet && reloadSet.values().next().value) refetch(true);
    }, [])
  );
}

export default useSubscribeToClientCardTasks;
